export enum DocumentType {
    CARTAO_CNPJ = 1,
    CONTRATO_SOCIAL = 2,
    ATA_SOCIETARIA = 3,
    DOCUMENTO_SOCIOS = 4,
    COMPROVANTE_ENDERECO = 5,
    OUTROS = 6
}

export interface IAttachments {
    id?: string
    dataCriacao: string
    storageId?: string
    tipoDocumento: DocumentType
    nomeArquivo: string
    instituicaoId?: number
}
